module.exports = __webpack_public_path__ + "img/patent7.853f865f.jpg";